"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFormRelMeta = exports.getFormSnapshot = exports.getFormClient = exports.getFormPermission = exports.getFieldPermissionMapFromForm = exports.getFormErrorCode = exports.getFormLoading = exports.getForm = void 0;
const datasheet_1 = require("../../../../../modules/database/store/selectors/resource/datasheet");
const store_1 = require("../../../../../exports/store");
const getFormPack = (state, id) => {
    var _a;
    const formId = id || state.pageParams.formId;
    if (!formId) {
        return null;
    }
    return (_a = state.formMap[formId]) !== null && _a !== void 0 ? _a : null;
};
const getForm = (state, id) => {
    const formPack = getFormPack(state, id);
    if (!formPack) {
        return null;
    }
    return formPack.form;
};
exports.getForm = getForm;
const getFormLoading = (state, id) => {
    const formPack = getFormPack(state, id);
    if (!formPack) {
        return false;
    }
    return formPack.loading;
};
exports.getFormLoading = getFormLoading;
const getFormErrorCode = (state, id) => {
    const formPack = getFormPack(state, id);
    if (!formPack) {
        return;
    }
    return formPack.errorCode;
};
exports.getFormErrorCode = getFormErrorCode;
const getFieldPermissionMapFromForm = (state, id) => {
    const form = (0, exports.getForm)(state, id);
    if (!form) {
        return;
    }
    return form.fieldPermissionMap;
};
exports.getFieldPermissionMapFromForm = getFieldPermissionMapFromForm;
const getFormPermission = (state, resourceId) => {
    const formPack = getFormPack(state, resourceId);
    if (!formPack || !formPack.form || !formPack.connected) {
        return store_1.DEFAULT_PERMISSION;
    }
    return formPack.form.permissions;
};
exports.getFormPermission = getFormPermission;
const getFormClient = (state, id) => {
    const formPack = getFormPack(state, id);
    if (!formPack) {
        return null;
    }
    return formPack.client;
};
exports.getFormClient = getFormClient;
const getFormSnapshot = (state, id) => {
    const form = (0, exports.getForm)(state, id);
    if (!form) {
        return null;
    }
    return form.snapshot;
};
exports.getFormSnapshot = getFormSnapshot;
const getFormRelMeta = (state, id) => {
    var _a;
    const sourceInfo = (_a = (0, exports.getForm)(state, id)) === null || _a === void 0 ? void 0 : _a.sourceInfo;
    if (!sourceInfo) {
        return null;
    }
    const { datasheetId, viewId } = sourceInfo;
    const datasheetSnapshot = (0, datasheet_1.getSnapshot)(state, datasheetId);
    if (!datasheetSnapshot) {
        return null;
    }
    const currentView = datasheetSnapshot.meta.views.filter(view => {
        return view.id === viewId;
    });
    if (!currentView.length) {
        return null;
    }
    return {
        fieldMap: datasheetSnapshot.meta.fieldMap,
        views: currentView,
    };
};
exports.getFormRelMeta = getFormRelMeta;
//# sourceMappingURL=form.js.map